import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SnippetRoute from "./routes/SnippetRoute";
import OverlayWrapperRoute from "./routes/OverlayWrapperRoute";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/snippet" element={<SnippetRoute />} />
        <Route path="/overlay" element={<OverlayWrapperRoute />} />
      </Routes>
    </Router>
  );
}

export default App;
